module.exports = "<div class=\"dropletBubble-fieldContainer\">\n  <label\n    :for=\"'section-center-' + activeDroplet._id\"\n    class=\"dropletBubble-checkLabel\">\n    {{ option.label }}\n  </label>\n  <input\n    :id=\"'section-center-' + activeDroplet._id\"\n    type=\"checkbox\"\n    v-model=\"display[option.payload.models.value.name]\"\n    class=\"dropletBubble-checkbox center-section\"\n    @change=\"onChange(option.payload)\"/>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/style-sidebar/options/section-options/flex-center-content/template.html
// module id = 7heO
// module chunks = 0